/* __next_internal_client_entry_do_not_use__ default auto */ import { jsx as _jsx } from "react/jsx-runtime";
import React, { useMemo } from 'react';
import { CheckoutProvider } from '@stripe/react-stripe-js/checkout';
import { loadStripe } from '@stripe/stripe-js';
import { useNewOrder } from '@/context/NewOrderContext';
import CheckoutForm from './CheckoutForm';
import { usePathname, useRouter } from 'next/navigation';
const stripePromise = loadStripe(process.env.NEXT_PUBLIC_STRIPE_PK);
function Summary() {
    const { order, setOrder, setStep } = useNewOrder();
    const router = useRouter();
    const pathname = usePathname();
    const promise = useMemo(()=>{
        if (!order || !order.stripe_product) return null;
        if (order.checkout_session_id) {
            return fetch("/api/checkout/session?session_id=".concat(order.checkout_session_id)).then((res)=>res.json()).then(async (data)=>{
                if ('error' in data) {
                    throw new Error(data.error);
                }
                if (data.payment_status === 'paid') {
                    router.push("/order-confirmation?session_id=".concat(data.id));
                    return data.client_secret;
                }
                if (data.expires_at < Math.floor(Date.now() / 1000)) {
                    const response = await fetch('/api/checkout/session', {
                        method: "POST",
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify({
                            order
                        })
                    });
                    if (!response.ok) {
                        const errorData = await response.json();
                        throw new Error(errorData.error || 'Failed to create checkout session');
                    }
                    const newData = await response.json();
                    setOrder((prev)=>({
                            ...prev,
                            checkout_session_id: newData.id
                        }));
                    router.replace("".concat(pathname, "?order_id=").concat(order.id));
                    return data.client_secret;
                }
                router.replace("".concat(pathname, "?order_id=").concat(order.id));
                return data.client_secret;
            }).catch((error)=>{
                console.error('Error retrieving checkout session:', error);
                setStep(5);
                return '';
            });
        } else {
            return fetch('/api/checkout/session', {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    order
                })
            }).then((res)=>res.json()).then(async (data)=>{
                if ('error' in data) {
                    throw new Error(data.error);
                }
                setOrder((prev)=>({
                        ...prev,
                        checkout_session_id: data.id
                    }));
                router.replace("".concat(pathname, "?order_id=").concat(order.id));
                return data.client_secret;
            }).catch((error)=>{
                console.error('Error creating checkout session:', error);
                setStep(5);
                return '';
            });
        }
    }, []);
    return /*#__PURE__*/ _jsx("div", {
        className: "mt-10",
        children: /*#__PURE__*/ _jsx(CheckoutProvider, {
            stripe: stripePromise,
            options: {
                clientSecret: promise ? promise : new Promise(()=>'')
            },
            children: /*#__PURE__*/ _jsx(CheckoutForm, {})
        })
    });
}
export default Summary;
